import { t } from "i18next";

type ErrorWithMessage = {
    message?: unknown;
    response?: {
        data?: {
            message?: unknown;
            errorMessage?: unknown;
        };
    };
};

export const getErrorMessage = (err: unknown): string => {
    if (typeof err === "string" && err.trim().length > 0) {
        return err;
    }

    const typedError = err as ErrorWithMessage;
    const responseMessage = typedError?.response?.data?.message;
    const responseErrorMessage = typedError?.response?.data?.errorMessage;
    const directMessage = typedError?.message;

    if (typeof responseMessage === "string" && responseMessage.trim().length > 0) {
        return t(responseMessage);
    }

    if (
        responseMessage &&
        typeof responseMessage === "object" &&
        "value" in responseMessage &&
        typeof (responseMessage as { value?: unknown }).value === "string"
    ) {
        return t(String((responseMessage as { value?: unknown }).value));
    }

    if (typeof responseErrorMessage === "string" && responseErrorMessage.trim().length > 0) {
        return t(responseErrorMessage);
    }

    if (typeof directMessage === "string" && directMessage.trim().length > 0) {
        return t(directMessage);
    }

    return t("common:form.systemError");
};
